import React from 'react'
import { motion } from 'framer-motion'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { IndianRupee } from 'lucide-react'

const AccountantPayments: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center space-x-2">
            <IndianRupee className="h-5 w-5 text-emerald-600" />
            <span>Payment Management</span>
          </CardTitle>
          <CardDescription>Comprehensive payment tracking and management</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-8">
            <p className="text-gray-600 mb-4">Payment management interface coming soon</p>
            <Badge variant="secondary">Under Development</Badge>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  )
}

export default AccountantPayments
